export const getLocationInfo = (venueName, venueAddress) => {
    //If we have both name and address add comma separated address
    if (venueAddress && venueName) {
        //ex. Eventbrite • San Francisco CA
        return `${venueName} \u2022 ${venueAddress}`;
    }

    return venueName || venueAddress;
};
